/* YLV – Your Luxury Vault · interaction layer (vanilla, no dependencies) */
(function () {
  'use strict';

  var YLV = (window.YLV = window.YLV || {});
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionEnabled = document.body && document.body.classList.contains('ylv-motion') && !reduceMotion;

  /* ---------------- Reveal on scroll ---------------- */
  var revealObserver = null;
  function initReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-ylv-reveal]:not(.is-revealed)');
    if (!items.length) return;
    scope.querySelectorAll('[data-ylv-stagger]').forEach(function (group) {
      var i = 0;
      group.querySelectorAll(':scope > [data-ylv-reveal], :scope > li > [data-ylv-reveal]').forEach(function (el) {
        if (!el.style.getPropertyValue('--ylv-delay')) el.style.setProperty('--ylv-delay', String(i % 6));
        i++;
      });
    });
    if (!motionEnabled || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }
  YLV.initReveal = initReveal;

  /* ---------------- Header scroll state ---------------- */
  function initHeader() {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    var ticking = false;
    function update() {
      wrapper.classList.toggle('ylv-is-scrolled', window.scrollY > 12);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------------- Product sliders ---------------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-ylv-slider]').forEach(function (wrap) {
      if (wrap.dataset.ylvSliderInit) return;
      wrap.dataset.ylvSliderInit = '1';
      var track = wrap.querySelector('.ylv-products--slider');
      var prev = wrap.querySelector('.ylv-prev');
      var next = wrap.querySelector('.ylv-next');
      if (!track) return;
      function step() {
        var item = track.querySelector('li');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function state() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        var nav = prev.closest('.ylv-slider-nav');
        if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(state); }, { passive: true });
      window.addEventListener('resize', state);
      state();
    });
  }

  /* ---------------- Smooth accordions (details.ylv-acc) ---------------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('details.ylv-acc').forEach(function (details) {
      if (details.dataset.ylvAccInit) return;
      details.dataset.ylvAccInit = '1';
      var summary = details.querySelector('summary');
      var body = details.querySelector('.ylv-acc__body');
      if (!summary || !body || reduceMotion || !body.animate) return;
      var anim = null;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) anim.cancel();
        if (details.open) {
          var h = body.offsetHeight;
          anim = body.animate({ height: [h + 'px', '0px'], opacity: [1, 0] }, { duration: 380, easing: 'cubic-bezier(0.22,0.61,0.24,1)' });
          anim.onfinish = function () { details.open = false; summary.setAttribute('aria-expanded', 'false'); anim = null; };
        } else {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
          var target = body.offsetHeight;
          anim = body.animate({ height: ['0px', target + 'px'], opacity: [0, 1] }, { duration: 460, easing: 'cubic-bezier(0.16,1,0.3,1)' });
          anim.onfinish = function () { anim = null; };
        }
      });
    });
  }

  /* ---------------- Collection: load more ---------------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ylv-load-more]');
    if (!btn) return;
    event.preventDefault();
    var url = btn.getAttribute('data-next-url');
    var grid = document.getElementById('product-grid');
    if (!url || !grid || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.querySelector('[data-label]');
    var original = label ? label.textContent : '';
    if (label) label.textContent = btn.getAttribute('data-loading-text') || original;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var newMore = doc.querySelector('[data-ylv-load-more-wrap]');
        var currentMore = document.querySelector('[data-ylv-load-more-wrap]');
        var added = newGrid ? newGrid.children.length : 0;
        if (newGrid) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(newGrid.children).forEach(function (li) { frag.appendChild(li); });
          grid.appendChild(frag);
          initReveal(grid);
          // keep theme scroll animations working for appended items
          grid.querySelectorAll('.scroll-trigger.scroll-trigger--offscreen').forEach(function (el) { el.classList.remove('scroll-trigger--offscreen'); });
          grid.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('animate--slide-in'); });
        }
        if (currentMore) {
          if (newMore) currentMore.replaceWith(newMore);
          else currentMore.remove();
        }
        var focusTarget = added ? grid.children[grid.children.length - added] : null;
        var link = focusTarget && focusTarget.querySelector('a[href]');
        if (link) link.focus({ preventScroll: true });
        if (window.history && window.history.replaceState) {
          try {
            var u = new URL(url, window.location.origin);
            var page = u.searchParams.get('page');
            var cur = new URL(window.location.href);
            if (page) { cur.searchParams.set('page', page); window.history.replaceState({}, '', cur.toString()); }
          } catch (e) { /* noop */ }
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = original;
      });
  });

  /* ---------------- Product page: availability live update ---------------- */
  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.html) return;
      var sectionId = event.data.sectionId;
      var html = event.data.html;
      ['YlvAvailability-', 'YlvCondition-'].forEach(function (prefix) {
        var id = prefix + sectionId;
        var current = document.getElementById(id);
        var fresh = html.getElementById ? html.getElementById(id) : null;
        if (current && fresh) current.innerHTML = fresh.innerHTML;
      });
    });
  }

  /* ---------------- Recently viewed ---------------- */
  var RV_KEY = 'ylv:recently-viewed';
  function readRV() {
    try { return JSON.parse(window.localStorage.getItem(RV_KEY) || '[]') || []; } catch (e) { return []; }
  }
  function writeRV(list) {
    try { window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 16))); } catch (e) { /* storage unavailable */ }
  }
  function trackProduct() {
    var el = document.querySelector('[data-ylv-track-product]');
    if (!el) return;
    var handle = el.getAttribute('data-ylv-track-product');
    if (!handle) return;
    var list = readRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeRV(list);
  }
  function initRecentlyViewed(root) {
    (root || document).querySelectorAll('[data-ylv-recently-viewed]').forEach(function (section) {
      if (section.dataset.ylvRvInit) return;
      section.dataset.ylvRvInit = '1';
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
      var exclude = section.getAttribute('data-exclude') || '';
      var sectionId = section.getAttribute('data-card-section') || 'ylv-card-render';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var handles = readRV().filter(function (h) { return h && h !== exclude; }).slice(0, limit);
      var list = section.querySelector('[data-ylv-rv-list]');
      if (!handles.length || !list) return;
      Promise.all(handles.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + sectionId, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (results) {
        var html = results.filter(Boolean).map(function (markup) {
          var doc = new DOMParser().parseFromString(markup, 'text/html');
          var card = doc.querySelector('.ylv-card');
          return card ? '<li data-ylv-reveal>' + card.outerHTML + '</li>' : '';
        }).join('');
        if (!html) return;
        list.innerHTML = html;
        section.hidden = false;
        initReveal(section);
      });
    });
  }

  /* ---------------- Floating consultation button ---------------- */
  function initFloat() {
    var btn = document.querySelector('.ylv-float');
    var footer = document.querySelector('.ylv-footer');
    if (!btn || !footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { btn.classList.toggle('is-hidden', entry.isIntersecting); });
    }).observe(footer);
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    initReveal();
    initHeader();
    initSliders();
    initAccordions();
    initVariantSync();
    trackProduct();
    initRecentlyViewed();
    initFloat();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initSliders(e.target);
    initAccordions(e.target);
    initRecentlyViewed(e.target);
  });
})();
